import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common"; 
import { CarouselComponent } from "./carousel.component";
import { CarouselAreaDirective } from "./carousel-area.directive";

const COMPONENTS = [
  CarouselComponent,
  CarouselAreaDirective
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule
  ],
  exports: COMPONENTS
})

export class CarouselModule { }

